import React from "react";
import {LayoutHero} from "../../Components/Layout/";
import {LinkButton} from "../../Components/Link";
import {locations} from "../../Utilities/Location";

interface LandingContainerProps {
    isLoggedIn?: boolean;
}

export const LandingContainer: React.FC<LandingContainerProps> = ({isLoggedIn}) => {

    return (
        <div className="contentArea">
            <LayoutHero>
                <div className="contentCard__title">
                    <h1>Welcome to the<br/>Media and Materials Loan Library!</h1>
                </div>

                <p className="contentCard__description">
                    The Media and Materials Loan Library allows approved individuals to access the system and
                    borrow materials on behalf of accounts registered with the Media and Materials Loan Library.
                </p>

                {!isLoggedIn && (
                    <div className="contentCard__actions">
                        <div className="contentCard__action-box">
                            <p className="contentCard__action-label">Register and request access to materials.</p>
                            <LinkButton {...locations.REGISTER.link} isExpanded/>
                        </div>
                        <div className="contentCard__action-box">
                            <p className="contentCard__action-label">Access an existing account.</p>
                            <LinkButton {...locations.SIGN_IN.link} isPrimary isExpanded/>
                        </div>
                    </div>
                )}
            </LayoutHero>
        </div>
    );
};
